import React from 'react';

export default class SearchBar2 extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('SearchBar - QueryText:', this.props.value);

		return (
			<form
				className="search-bar"
				onSubmit={this.props.onSubmit}
				autoComplete="off"
			>
				<div className="input-group">
					<span className="fa fa-search search-icon" />
					<input
						className="form-control"
						type="text"
						autoComplete="off"
						placeholder={this.props.placeholder}
						name={this.props.name}
						value={this.props.value}
						onChange={this.props.onChange}
					/>
				</div>
			</form>
		);
	}
}
